var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWallColor(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_wall_color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_wall_color",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(12.500000, 12.000000) rotate(-45.000000) translate(-12.500000, -12.000000) translate(6.000000, 3.000000)",
    stroke: "#010101",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.375,7.74243164 L12.375,9.86743164 C12.375,10.9720011 11.4795695,11.8674316 10.375,11.8674316 L7.869,11.8664316 L7.86945801,16.2183197 C7.86945801,17.1472395 7.11641976,17.9002777 6.1875,17.9002777 C5.25858024,17.9002777 4.50554199,17.1472395 4.50554199,16.2183197 L4.505,11.8664316 L2,11.8674316 C0.8954305,11.8674316 -8.67738547e-17,10.9720011 0,9.86743164 L0,7.74243164 L12.375,7.74243164 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    strokeLinecap: "round",
    points: "0 4.75022888 0 -5.12923037e-14 6.56599426 -5.12923037e-14 8.62060547 1.98008728 10.6109314 -5.12923037e-14 12.375 -5.12923037e-14 12.375 7.74243164"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallColor);
export default __webpack_public_path__ + "static/media/icon_wall_color.930306b37dc2323cd2ba368e9863baf8.svg";
export { ForwardRef as ReactComponent };